var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll-list" },
    [
      _c(
        "div",
        {
          directives: [
            { name: "stick-in-parent", rawName: "v-stick-in-parent" }
          ],
          staticClass: "scroll-list__hl-wrapper"
        },
        [
          _c(
            "ul",
            { staticClass: "scroll-list__headline" },
            _vm._l(_vm.items, function(item) {
              return _c(
                "li",
                {
                  staticClass: "scroll-list__nav-item",
                  class: {
                    "scroll-list__nav-item--active": _vm.activeId === item.uuid
                  },
                  attrs: { "data-uuid": item.uuid }
                },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.scrollTo(item.uuid)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.title))]
                  )
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          { staticClass: "scroll-list__content", attrs: { id: item.uuid } },
          [_vm._t("slot" + item.uuid)],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }